import * as React from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import { ObjValidator } from "components";
import { useTranslate } from "hooks";
import type { ObjValidatorProps } from "interfaces/shared.types";

const LibraryList = Scrivito.connect(({ page }: ObjValidatorProps) => {
  const translate = useTranslate();
  if (!page) return null;

  return (
    <div className="pt-4 bg-gray-100">
      <Container className="pb-8">
        <Scrivito.ContentTag
          className="text-uppercase"
          content={page}
          attribute="title"
          tag="h3"
        />
        <Scrivito.ContentTag content={page} attribute="subtitle" tag="h4" />
        <h2>{translate("UNDER_CONSTRUCTION")}</h2>
      </Container>
    </div>
  );
});

const CheckedPage = (props: ObjValidatorProps) => (
  <ObjValidator {...props} page={props.page}>
    <LibraryList {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("LibraryList", CheckedPage);
